import { render, staticRenderFns } from "./PurchaseAnalysisTreeMap.vue?vue&type=template&id=1281fc0e"
import script from "./PurchaseAnalysisTreeMap.vue?vue&type=script&lang=ts"
export * from "./PurchaseAnalysisTreeMap.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports